document.addEventListener('click', (event) => {
    const generalCheckoutSelector = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [class*="checkout"], .identixweb-checkout';
    const clickedCheckoutElement = event.target.closest(generalCheckoutSelector);

    let isValidated = true;
    if (clickedCheckoutElement.getAttribute("disabled") == "true" || clickedCheckoutElement.querySelector("a")?.getAttribute("disabled") == "true") {
        isValidated = false;
    }

    if (clickedCheckoutElement && window.hulkapps !== undefined && typeof is_draft_order !== 'undefined' && is_draft_order && isValidated) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        // hulkappsCheckout();
         if (typeof IntegrationCheckoutClick === 'undefined') {
            hulkappsCheckout();
        } else {
            console.log("Inside IntegrationCheckoutClick");
            var result = IntegrationCheckoutClick();
            if (result.required == true) {
                hulkappsCheckout(result);
            }
        }
    }
}, true);
